
// import React, { useEffect, useState } from "react";
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import ph from '../Resources/wp.png';
// import tele from '../Resources/telephone.png'
// import "../Styles/Hero.css";
// import salalogo from '../Resources/salalogo1.webp';
// import EnquirePopup from './EnquirePopUp'

// export default function SalaHero() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     AOS.init({
//       duration: 3000,
//       easing: 'ease-in-out',
//       once: true,
//       offset: 0,
//     });
//   }, []);

//   useEffect(() => {
//   const handleScroll = () => {
//     const scrolledPastHero = window.scrollY >= window.innerHeight;
//     setScrolled(scrolledPastHero);
//   };

//   window.addEventListener("scroll", handleScroll);
//   return () => window.removeEventListener("scroll", handleScroll);
// }, []);



//   return (
//     <div className="Sala-Hero-Container" id="home">

//       {/* Navbar */}
//       <div className={`Sala-Hero-Navbar-container ${scrolled ? 'navbar-scrolled' : ''}`} data-aos="fade-down" data-aos-delay="100">
//         <div className="Sala-hero-logo-placer">
//         <img src={salalogo} className="Sala-hero-logo" alt="SALA Logo" data-aos="fade-right" data-aos-delay="200" />
//         <h1>The Sala</h1>
//         </div>

//         <div className="Sala-nav-links" data-aos="fade-down" data-aos-delay="300">
//           <a href="#home">Home</a>
//           <a href="#about">About</a>
//           <a href="#features">Features</a>
//           <a href="#contact">Contact</a>
//         </div>

//         <div data-aos="fade-left" data-aos-delay="400">
//           {/* <a href="#contact"> */}
//             <button className="Sala-Hero-Navbar-btn" onClick={() => setShowPopup(true)}>Enquire Now</button>
//           {/* </a> */}
//         </div>

//         {/* Hamburger */}
//         {/* <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//           <span></span>
//           <span></span>
//           <span></span>
//         </div> */}
//         <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//           {menuOpen ? (
//             <div className="close-icon">✕</div>
//           ) : (
//             <>
//               <span></span>
//               <span></span>
//               <span></span>
//             </>
//           )}
//         </div>


//       </div>

//       {/* Mobile Menu Overlay */}
//       {menuOpen && (
//         <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}>
//           <div className="mobile-menu" onClick={e => e.stopPropagation()}>
//             <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
//             <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
//             <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
//             <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
//           </div>
//         </div>
//       )}

//       <div className="hero-icons-placer">
//         <div><img src={tele} className="hero-icons-placer-img"></img></div>
//         <div><img src={ph} className="hero-icons-placer-img"></img></div>
//       </div>

//       {/* Hero Heading */}
//       <div className="Sala-Hero-H1" data-aos="fade-up" data-aos-delay="600">
//         <span className="Sala_hero-h1-span1">
//           <h1>Own a Villa</h1>
//           <h1>Steeped in Royalty</h1>
//         </span>
//         <div className="Sala_hero-h1-span2"></div>
//         <span className="Sala_hero-h1-span3">
//           <h1>Where heritage meets elegance </h1>
//           <h1>every inch promises exceptional returns.</h1>
//         </span>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import ph from '../Resources/wp.png';
import tele from '../Resources/telephone.png';
import enq from '../Resources/enquire.png';

import { motion, AnimatePresence } from "framer-motion"; // Import framer-motion

import "../Styles/Hero.css";
import salalogo from '../Resources/salalogo1.webp';
import EnquirePopup from "./EnquirePopUp";

import { trackWhatsApp } from "../utils/Tracking"; // Import tracking function

// Import images for slider
import bg1 from '../Resources/salaherobg.avif';
import bg2 from '../Resources/about-img1.jpg';
import bg3 from '../Resources/about-img3.JPG';
import bg4 from '../Resources/about-img2.jpg';

const images = [bg1, bg2, bg3, bg4];

export default function SalaHero() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 3000,
      easing: 'ease-in-out',
      once: true,
      offset: 0,
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Hide button when scrolling past the hero section (viewport height)
      const scrolledPastHero = window.scrollY >= window.innerHeight;
      setScrolled(scrolledPastHero);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Show Popup on Load Logic
  useEffect(() => {
    const openTimer = setTimeout(() => {
      setShowPopup(true);
    }, 2000);

    return () => clearTimeout(openTimer);
  }, []);

  // Image Slider Logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="Sala-Hero-Container" id="home">
      {/* Background Slider */}
      <AnimatePresence mode="popLayout">
        <motion.div
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5 }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${images[currentImageIndex]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0
          }}
        />
      </AnimatePresence>

      {/* Overlay Filter (match CSS) */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 1
      }}></div>

      {/* Navbar */}
      <div className={`Sala-Hero-Navbar-container ${scrolled ? 'navbar-scrolled' : ''}`} data-aos="fade-down" data-aos-delay="100">
        <div className="Sala-hero-logo-placer">
          <img src={salalogo} className="Sala-hero-logo" alt="SALA Logo" data-aos="fade-right" data-aos-delay="200" />
          <h1>The Sala</h1>
        </div>

        <div className="Sala-nav-links" data-aos="fade-down" data-aos-delay="300">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#features">Features</a>
          <a href="#gallery">Gallery</a>
          <a href="#contact">Contact</a>
        </div>

        <div data-aos="fade-left" data-aos-delay="400">
          <button className="Sala-Hero-Navbar-btn" onClick={() => setShowPopup(true)}>
            Enquire Now
          </button>
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <div className="close-icon">✕</div>
          ) : (
            <>
              <span></span>
              <span></span>
              <span></span>
            </>
          )}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="mobile-menu" onClick={e => e.stopPropagation()}>
            <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
            <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
            <a href="#gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
            <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
            <button
              className="Sala-Hero-Navbar-btn mobile-menu-enquire-btn"
              onClick={() => {
                setShowPopup(true);
                setMenuOpen(false);
              }}
            >
              Enquire Now
            </button>
          </div>
        </div>
      )}

      <div className="hero-icons-placer">
        <a href="tel:9986800600">
          <div><img src={tele} className="hero-icons-placer-img-tel" alt="telephone" /></div>
        </a>
        <a href="https://api.whatsapp.com/send/?phone=919986800600&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" onClick={trackWhatsApp}>
          <div><img src={ph} className="hero-icons-placer-img-wt" alt="whatsapp" /></div>
        </a>
        <div><img src={enq} className="hero-icons-placer-img-en" onClick={() => setShowPopup(true)} alt="enquire" /></div>
      </div>

      {/* Hero Heading */}
      <div className="Sala-Hero-H1" data-aos="fade-up" data-aos-delay="600">
        <span className="Sala_hero-h1-span1">
          <h1>Own a Villa</h1>
          <h1>Steeped in Royalty</h1>
        </span>
        <div className="Sala_hero-h1-span2"></div>
        <span className="Sala_hero-h1-span3">
          <h1>Where heritage meets elegance</h1>
          <h1>every inch promises exceptional returns.</h1>
        </span>
      </div>

      {/* ✅ Popup rendered here */}
      <EnquirePopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
}
